<style scoped>
.form-error {
  color: red;
  margin-left: 0;
  margin-top: -14px;
}
</style>
<template>
  <form style="width:100%">
    <v-tabs v-model="tab">
      <v-tab
        ><img
          style="width:3rem;display: block;margin-left: auto;margin-right: auto"
          :src="'/assets/technology/ttn.png'"
          :key="0"
        />
        TTN</v-tab
      >
      <v-tab
        ><img
          style="width:3rem;display: block;margin-left: auto;margin-right: auto"
          :src="'/assets/technology/loriot.png'"
          :key="1"
        />
        Loriot</v-tab
      >
      <v-tab
        ><img
          style="width:3rem;display: block;margin-left: auto;margin-right: auto"
          :src="'/assets/technology/machineq.png'"
          :key="2"
        />
        MachineQ</v-tab
      >
      <v-tab
        ><img
          style="width:3rem;display: block;margin-left: auto;margin-right: auto"
          :src="'/assets/technology/actility.png'"
          :key="3"
        />
        Actility</v-tab
      >
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="0">
        <div style="witdth:100%;">
          <img
            style="width:8rem;display: block;margin-left: auto;margin-right: auto"
            :src="'/assets/technology/ttn.png'"
          />
        </div>
        <v-layout row wrap align-center>
          <v-flex xs12 style="margin-bottom:2rem">
            <div>
              <p style="margin-bottom:0" class="body-2">
                <v-icon small>memory</v-icon> Device EUI
              </p>
              <p style="margin-bottom:0" class="caption">
                {{ ttn.device_eui.hint }}
              </p>
            </div>
            <v-text-field
              ref="device_eui"
              name="device_eui"
              :label="ttn.device_eui.label"
              v-validate="
                'required|min:' +
                  ttn.device_eui.min +
                  '|max:' +
                  ttn.device_eui.max +
                  '|regex:' +
                  ttn.device_eui.regExp
              "
              :counter="ttn.device_eui.max"
              required="true"
              v-model="model.device_eui"
              :error="errors.first('device_eui') != undefined"
            ></v-text-field>
            <div
              v-show="errors.first('device_eui')"
              class="form-error caption"
              style="text-align:left"
            >
              {{ errors.first("device_eui") }}
            </div>
          </v-flex>

          <v-flex xs12>
            <v-form>
              <v-layout row wrap align-center>
                <v-flex xs12 style="margin-bottom:2rem">
                  <div>
                    <p style="margin-bottom:0" class="body-2">Device profile</p>
                    <p style="margin-bottom:0" class="caption">
                      Select existing device profile
                    </p>
                  </div>
                  <v-select
                    :items="filteredDeviceProfiles"
                    label="Select device profile"
                    item-value="id"
                    item-text="id"
                    v-model="model.device_profile"
                    v-validate="'required'"
                    ref="device_profile"
                    name="device_profile"
                  ></v-select>
                  <div
                    v-show="errors.first('device_profile')"
                    class="form-error caption"
                    style="text-align:left"
                  >
                    {{ errors.first("device_profile") }}
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>

          <v-flex xs12 style="margin-bottom:2rem">
            <v-checkbox
              v-model="model.manual_provisioning"
              label="Provision device manually (not through this web app)"
              :true-value="true"
              :false-value="false"
            ></v-checkbox>

            <div
              v-if="model.manual_provisioning"
              class="caption"
              style="color: #888; margin-bottom: 1rem;"
            >
              Device provisioning fields below are disabled because manual
              provisioning is selected.
            </div>
          </v-flex>

          <div style="width: 100%;">
            <v-flex xs12 style="margin-bottom:2rem">
              <div>
                <p style="margin-bottom:0" class="body-2">
                  LoRa WAN Version (optional)
                </p>
                <p style="margin-bottom:0" class="caption">
                  {{ ttn.lora_wan_version.hint }}
                </p>
              </div>
              <v-select
                :items="ttn.lora_wan_version.values"
                :label="ttn.lora_wan_version.label"
                item-value="ref"
                item-text="text"
                v-model="model.lora_wan_version"
                ref="lora_wan_version"
                name="lora_wan_version"
                :disabled="model.manual_provisioning"
              ></v-select>
              <div
                v-show="errors.first('lora_wan_version')"
                class="form-error caption"
                style="text-align:left"
              >
                {{ errors.first("lora_wan_version") }}
              </div>
            </v-flex>

            <v-flex xs12 style="margin-bottom:2rem">
              <div>
                <p style="margin-bottom:0" class="body-2">
                  LoRa PHY Version (optional)
                </p>
                <p style="margin-bottom:0" class="caption">
                  {{ ttn.lora_wan_phy_version.hint }}
                </p>
              </div>
              <v-select
                :items="ttn.lora_wan_phy_version.values"
                :label="ttn.lora_wan_phy_version.label"
                item-value="ref"
                item-text="text"
                v-model="model.lora_wan_phy_version"
                ref="lora_wan_phy_version"
                name="lora_wan_phy_version"
                :disabled="model.manual_provisioning"
              ></v-select>
              <div
                v-show="errors.first('lora_wan_phy_version')"
                class="form-error caption"
                style="text-align:left"
              >
                {{ errors.first("lora_wan_phy_version") }}
              </div>
            </v-flex>

            <v-flex xs12 style="margin-bottom:2rem">
              <div>
                <p style="margin-bottom:0" class="body-2">
                  Frequency plan ID (optional)
                </p>
                <p style="margin-bottom:0" class="caption">
                  {{ ttn.frequency_plan_id.hint }}
                </p>
              </div>
              <v-select
                :items="ttn.frequency_plan_id.values"
                :label="ttn.frequency_plan_id.label"
                item-value="ref"
                item-text="text"
                v-model="model.frequency_plan_id"
                ref="frequency_plan_id"
                name="frequency_plan_id"
                :disabled="model.manual_provisioning"
              ></v-select>
              <div
                v-show="errors.first('frequency_plan_id')"
                class="form-error caption"
                style="text-align:left"
              >
                {{ errors.first("frequency_plan_id") }}
              </div>
            </v-flex>
          </div>
        </v-layout>
      </v-tab-item>

      <v-tab-item :key="1">
        <div style="witdth:100%;">
          <img
            style="width:8rem;display: block;margin-left: auto;margin-right: auto"
            :src="'/assets/technology/loriot.png'"
          />
        </div>
        <v-layout row wrap align-center>
          <v-flex xs12 style="margin-bottom:2rem">
            <div>
              <p style="margin-bottom:0" class="body-2">
                <v-icon small>memory</v-icon> Device EUI
              </p>
              <p style="margin-bottom:0" class="caption">
                {{ loriot.device_eui.hint }}
              </p>
            </div>
            <v-text-field
              ref="device_eui"
              name="device_eui"
              :label="loriot.device_eui.label"
              v-validate="
                'required|min:' +
                  loriot.device_eui.min +
                  '|max:' +
                  loriot.device_eui.max +
                  '|regex:' +
                  loriot.device_eui.regExp
              "
              :counter="loriot.device_eui.max"
              required="true"
              v-model="model.device_eui"
              :error="errors.first('device_eui') != undefined"
            ></v-text-field>
            <div
              v-show="errors.first('device_eui')"
              class="form-error caption"
              style="text-align:left"
            >
              {{ errors.first("device_eui") }}
            </div>
          </v-flex>

          <v-flex xs12>
            <v-form>
              <v-layout row wrap align-center>
                <v-flex xs12 style="margin-bottom:2rem">
                  <div>
                    <p style="margin-bottom:0" class="body-2">Device profile</p>
                    <p style="margin-bottom:0" class="caption">
                      Select existing device profile
                    </p>
                  </div>
                  <v-select
                    :items="filteredDeviceProfiles"
                    label="Select device profile"
                    item-value="id"
                    item-text="id"
                    v-model="model.device_profile"
                    v-validate="'required'"
                    ref="device_profile"
                    name="device_profile"
                  ></v-select>
                  <div
                    v-show="errors.first('device_profile')"
                    class="form-error caption"
                    style="text-align:left"
                  >
                    {{ errors.first("device_profile") }}
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item :key="2">
        <div style="witdth:100%;">
          <img
            style="width:8rem;display: block;margin-left: auto;margin-right: auto"
            :src="'/assets/technology/machineq.png'"
          />
        </div>
        <v-layout row wrap align-center>
          <v-flex xs12 style="margin-bottom:2rem">
            <div>
              <p style="margin-bottom:0" class="body-2">
                <v-icon small>memory</v-icon> Device EUI
              </p>
              <p style="margin-bottom:0" class="caption">
                {{ machineq.device_eui.hint }}
              </p>
            </div>
            <v-text-field
              ref="device_eui"
              name="device_eui"
              :label="machineq.device_eui.label"
              v-validate="
                'required|min:' +
                  machineq.device_eui.min +
                  '|max:' +
                  machineq.device_eui.max +
                  '|regex:' +
                  machineq.device_eui.regExp
              "
              :counter="machineq.device_eui.max"
              required="true"
              v-model="model.device_eui"
              :error="errors.first('device_eui') != undefined"
            ></v-text-field>
            <div
              v-show="errors.first('device_eui')"
              class="form-error caption"
              style="text-align:left"
            >
              {{ errors.first("device_eui") }}
            </div>
          </v-flex>

          <v-flex xs12>
            <v-form>
              <v-layout row wrap align-center>
                <v-flex xs12 style="margin-bottom:2rem">
                  <div>
                    <p style="margin-bottom:0" class="body-2">Device profile</p>
                    <p style="margin-bottom:0" class="caption">
                      Select existing device profile
                    </p>
                  </div>
                  <v-select
                    :items="filteredDeviceProfiles"
                    label="Select device profile"
                    item-value="id"
                    item-text="id"
                    v-model="model.device_profile"
                    v-validate="'required'"
                    ref="device_profile"
                    name="device_profile"
                  ></v-select>
                  <div
                    v-show="errors.first('device_profile')"
                    class="form-error caption"
                    style="text-align:left"
                  >
                    {{ errors.first("device_profile") }}
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item :key="3">
        <div style="witdth:100%;">
          <img
            style="width:8rem;display: block;margin-left: auto;margin-right: auto"
            :src="'/assets/technology/actility.png'"
          />
        </div>
        <v-layout row wrap align-center>
          <v-flex xs12 style="margin-bottom:2rem">
            <div>
              <p style="margin-bottom:0" class="body-2">
                <v-icon small>memory</v-icon> Device EUI
              </p>
              <p style="margin-bottom:0" class="caption">
                {{ actility.device_eui.hint }}
              </p>
            </div>
            <v-text-field
              ref="device_eui"
              name="device_eui"
              :label="actility.device_eui.label"
              v-validate="
                'required|min:' +
                  actility.device_eui.min +
                  '|max:' +
                  actility.device_eui.max +
                  '|regex:' +
                  actility.device_eui.regExp
              "
              :counter="actility.device_eui.max"
              required="true"
              v-model="model.device_eui"
              :error="errors.first('device_eui') != undefined"
            ></v-text-field>
            <div
              v-show="errors.first('device_eui')"
              class="form-error caption"
              style="text-align:left"
            >
              {{ errors.first("device_eui") }}
            </div>
          </v-flex>

          <v-flex xs12>
            <v-form>
              <v-layout row wrap align-center>
                <v-flex xs12 style="margin-bottom:2rem">
                  <div>
                    <p style="margin-bottom:0" class="body-2">Device profile</p>
                    <p style="margin-bottom:0" class="caption">
                      Select existing device profile
                    </p>
                  </div>
                  <v-select
                    :items="filteredDeviceProfiles"
                    label="Select device profile"
                    item-value="id"
                    item-text="id"
                    v-model="model.device_profile"
                    v-validate="'required'"
                    ref="device_profile"
                    name="device_profile"
                  ></v-select>
                  <div
                    v-show="errors.first('device_profile')"
                    class="form-error caption"
                    style="text-align:left"
                  >
                    {{ errors.first("device_profile") }}
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
    <v-btn block dark v-on:click="submit()" color="#39a9dc"> Submit </v-btn>
  </form>
</template>
<script>
import {mapState} from "vuex";
import * as iotServicesSdk from "iot-services-sdk";

export default {
  props: {
    model: Object,
    deviceProfiles: Array,
  },
  data() {
    return {
      tab: 0,
    };
  },

  watch: {
    "model.device_profile": {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          const foundProfile = this.deviceProfiles.find(
            (dp) => dp.id === newValue
          );
          if (foundProfile) {
            this.model.frequency_plan_id = this.ttn.frequency_plan_id.default[
              foundProfile.context.region
            ];

            if (this.ttn.lora_wan_phy_version.default[this.model.technology]) {
              this.model.lora_wan_phy_version = this.ttn.lora_wan_phy_version.default[
                this.model.technology
              ];
            }

            if (this.ttn.lora_wan_version.default[this.model.technology]) {
              this.model.lora_wan_version = this.ttn.lora_wan_version.default[
                this.model.technology
              ];
            }
          }
        }
      },
    },
  },
  computed: {
    ...mapState({
      newDevice: (state) => state.metadata.models.data.newDevice,
      deviceProfiles: (state) => state.deviceProfiles.deviceProfiles,
    }),

    filteredDeviceProfiles() {
      switch (this.tab) {
        case 0:
          return this.deviceProfiles.filter(
            (dp) =>
              dp.connectivity ===
              iotServicesSdk.shared.types.DeviceConnectivity.LORA_TTN
          );
        case 1:
          return this.deviceProfiles.filter(
            (dp) =>
              dp.connectivity ===
              iotServicesSdk.shared.types.DeviceConnectivity.LORA_LORIOT
          );
        case 2:
          return this.deviceProfiles.filter(
            (dp) =>
              dp.connectivity ===
              iotServicesSdk.shared.types.DeviceConnectivity.LORA_MACHINEQ
          );
        case 3:
          return this.deviceProfiles.filter(
            (dp) =>
              dp.connectivity ===
              iotServicesSdk.shared.types.DeviceConnectivity.LORA_ACTILITY
          );
        default:
          return this.deviceProfiles;
      }
    },

    loriot() {
      const deviceEuiModel = this.newDevice.fields.find(
        (f) => f.name == "device_eui"
      );
      return {
        device_eui: {
          label: deviceEuiModel.label,
          hint: deviceEuiModel.hint,
          regExp: deviceEuiModel.regexp.value,
          upperCase: deviceEuiModel.regexp.autoUpperCase,
          min: deviceEuiModel.min,
          max: deviceEuiModel.max,
        },
      };
    },

    machineq() {
      const deviceEuiModel = this.newDevice.fields.find(
        (f) => f.name == "device_eui"
      );
      return {
        device_eui: {
          label: deviceEuiModel.label,
          hint: deviceEuiModel.hint,
          regExp: deviceEuiModel.regexp.value,
          upperCase: deviceEuiModel.regexp.autoUpperCase,
          min: deviceEuiModel.min,
          max: deviceEuiModel.max,
        },
      };
    },

    actility() {
      const deviceEuiModel = this.newDevice.fields.find(
        (f) => f.name == "device_eui"
      );
      return {
        device_eui: {
          label: deviceEuiModel.label,
          hint: deviceEuiModel.hint,
          regExp: deviceEuiModel.regexp.value,
          upperCase: deviceEuiModel.regexp.autoUpperCase,
          min: deviceEuiModel.min,
          max: deviceEuiModel.max,
        },
      };
    },

    ttn() {
      const loraWanVersionModel = this.newDevice.fields.find(
        (f) => f.name == "lora_wan_version"
      );
      const loraWanPhyVersionModel = this.newDevice.fields.find(
        (f) => f.name == "lora_wan_phy_version"
      );
      const frequencyPlanIdModel = this.newDevice.fields.find(
        (f) => f.name == "frequency_plan_id"
      );
      const deviceEuiModel = this.newDevice.fields.find(
        (f) => f.name == "device_eui"
      );
      return {
        device_eui: {
          label: deviceEuiModel.label,
          hint: deviceEuiModel.hint,
          regExp: deviceEuiModel.regexp.value,
          upperCase: deviceEuiModel.regexp.autoUpperCase,
          min: deviceEuiModel.min,
          max: deviceEuiModel.max,
        },
        lora_wan_version: {
          default: loraWanVersionModel.default,
          label: loraWanVersionModel.label,
          hint: loraWanVersionModel.hint,
          regExp: loraWanVersionModel.regexp.value,
          upperCase: loraWanVersionModel.regexp.autoUpperCase,
          min: loraWanVersionModel.min,
          max: loraWanVersionModel.max,
          values: loraWanVersionModel.values,
        },
        lora_wan_phy_version: {
          default: loraWanPhyVersionModel.default,
          label: loraWanPhyVersionModel.label,
          hint: loraWanPhyVersionModel.hint,
          regExp: loraWanPhyVersionModel.regexp.value,
          upperCase: loraWanPhyVersionModel.regexp.autoUpperCase,
          min: loraWanPhyVersionModel.min,
          max: loraWanPhyVersionModel.max,
          values: loraWanPhyVersionModel.values,
        },
        frequency_plan_id: {
          default: frequencyPlanIdModel.default,
          label: frequencyPlanIdModel.label,
          hint: frequencyPlanIdModel.hint,
          regExp: frequencyPlanIdModel.regexp.value,
          upperCase: frequencyPlanIdModel.regexp.autoUpperCase,
          min: frequencyPlanIdModel.min,
          max: frequencyPlanIdModel.max,
          values: frequencyPlanIdModel.values,
        },
      };
    },
  },

  mounted() {
    this.model.network_provider = "ttn";
    this.tab = 0;
    this.model.lora_wan_version = this.ttn.lora_wan_version.default;
    this.model.lora_wan_phy_version = this.ttn.lora_wan_phy_version.default;
  },

  methods: {
    async submit() {
      switch (this.tab) {
        case 0:
          this.model.network_provider = "ttn";
          break;
        case 1:
          this.model.network_provider = "loriot";
          break;
        case 2:
          this.model.network_provider = "machineq";
          break;
        case 3:
          this.model.network_provider = "actility";
          break;
        default:
          throw "Network provider unknown";
      }
      return new Promise(
        async (resolve, reject) =>
          await this.$validator.validate().then((valid) => {
            if (valid) {
              this.$emit("submit");
              resolve();
            } else {
              reject();
            }
          })
      );
    },
  },
};
</script>
